export const kitchenDashboardTranslations = {
  en: {
    kitchenDashboard: {
      title: 'Kitchen Basic Information',
      unnamedKitchen: 'Unnamed Kitchen',
      contactTitle: 'Contact',
      addressVisibleLabel: 'Address Visible to Public',
      error: 'Sorry, an error occurred while saving!',
      addressError: 'The address entered was not found',
      loading: 'Loading data...',
    },
    kitchenSettings: {
      nameTitle: 'Choose the name for your kitchen',
      nameDescription: 'This is the name customers will see when they search. Your phone number is only shared after an order is placed.',
      locationTitle: "Enter your kitchen's location",
      locationNote: 'Location must be within Palm Beach, Broward or Miami Dade county',
      labelName: 'Kitchen Name',
      labelPhone: 'Kitchen Phone',
      labelAddress: 'Address',
      labelCity: 'City',
      labelState: 'State',
      labelZip: 'Zip Code',
      labelCountry: 'Country',
      cancel: 'Cancel',
      save: 'Save Changes',
      validation: {
        required: 'Required',
        state: 'State must be {state}',
        zipOnlyNumbers: 'Must contain only numbers',
        zipLength: 'Must be exactly 5 digits',
        phoneIncomplete: 'Phone number incomplete',
        phoneTooLong: 'Phone number too long',
      },
    },
    kitchenStatusPanel: {
      title: 'Status',
      selectFile: 'Please select a file',
      uploadError: 'Error uploading file',
      changeProfilePicture: 'Change Profile Picture',
      onlinePrompt: 'Say you are ready to take orders right now.',
      currently: 'Currently:',
      isReadyLabel: 'Kitchen Visibility:',
      isReady: "I'm ready! I want my kitchen visible to public",
      readyVisibilityNote: 'You can uncheck this option if you need to go offline (not visible) for a while.',
    },
    kitchenServices: {
      title: 'Services',
      delivery: 'Delivery',
      deliveryChargePrompt: 'Select delivery charge per mile',
      noCharge: 'No charge',
      pickup: 'Pickup',
      perMile: '${amount}/mile',
    },
    kitchenPaymentPreferences: {
      title: 'Payment Preferences',
      whenToPay: 'When to get paid',
      howToPay: 'How to get paid',
      payAtPickup: 'Pay at pickup',
      upfront: 'Upfront',
      cash: 'Cash',
      paymentApps: 'Payment Apps (Zelle, Venmo, etc.)',
      other: 'Other',
    },
    kitchenMenus: {
      title: 'Menus',
      menuItemsLabel: 'Menu Items',
      emptyState: 'No existing menus yet, please create your first Menu here.',
      createPrompt: 'You can create different menus based on your culinary themes and preferences.',
      createButton: 'Create Brand New Menu',
      newMenuTitle: 'New Menu',
      inactive: 'Inactive',
      active: 'Active',
      cancel: 'Cancel',
      saveNew: 'Save New Menu',
      nameLabel: 'Name',
      typeLabel: 'Type',
      examples: 'e.g. "My Lunch Menu", "To Share", "Dessert Delights"',
      editMenu: 'Edit Menu',
      deleteMenu: 'Delete Menu',
      deleteMenuConfirm: 'Do you want to delete this menu with all the menu items in it?',
      yes: 'Yes',
      validation: {
        required: 'Required',
        specialChars: 'Special characters < and > are not allowed',
        minLength: 'Must be at least 3 characters',
        maxLength: 'Must be less than 100 characters',
        noNumbers: 'Numbers are not allowed',
        letterRequired: 'Must contain at least one letter',
      },
      menuTypes: {
        any: 'Any',
        seafood: 'Seafood',
        vegetarian: 'Vegetarian',
        vegan: 'Vegan',
        meat_poultry: 'Meat & Poultry',
      },
      menuTypeDescriptions: {
        any: 'Flexible menu that can include any mix of dishes.',
        seafood: 'Focused on fish and shellfish-based dishes.',
        vegetarian: 'Plant-focused menu with no meat or seafood.',
        vegan: 'Fully plant-based menu with no animal products.',
        meat_poultry: 'Includes dishes with meat and poultry options.',
      },
      removeError: 'Sorry, an error occurred when removing menu',
      noMenuItems: 'No menu items added yet',
      activeStatus: 'active',
      inactiveStatus: 'inactive',
    },
    menuItems: {
      selectFile: 'Please select a file',
      pictureUploadError: 'Picture could not be uploaded',
      uploadError: 'Error uploading file',
      uploadFailure: 'Sorry, {message}',
      changePicture: 'Change Picture',
      timeToPrepare: 'Time to prepare',
      minutes: 'minutes',
      ingredients: 'Ingredients',
      description: 'Description',
      editMenuItem: 'Edit Menu Item',
      addNewItem: 'Add New Item To This Menu',
      newItem: 'New Item',
      itemName: 'Item Name',
      timeLabel: 'Time to Prepare',
      categoryLabel: 'Category',
      priceLabel: 'Price',
      ingredientsLabel: 'Ingredients',
      descriptionLabel: 'Description',
      itemPlaceholder: 'List Ingredients separeted by comma',
      descriptionPlaceholder: 'Describe your product here',
      min: 'min',
      removeMenuItem: 'Remove Menu Item',
      removeMenuItemConfirm: 'Do you want to remove {itemName} from your menu?',
      deletePrompt: 'Do you want to delete this menu with all the menu items in it?',
      save: 'Save',
      validation: {
        required: 'Required',
        minLength: 'Must be at least 3 characters',
        maxLength: 'Must be less than 100 characters',
        ingredientMin: 'Must be at least 3 characters',
        ingredientMax: 'Must be less than 500 characters',
        descriptionMin: 'Must be at least 10 characters',
        descriptionMax: 'Must be less than 500 characters',
        priceRequired: 'Required',
        timeRequired: 'Required',
        categoryRequired: 'Required',
      },
    },
  },
  es: {
    kitchenDashboard: {
      title: 'Información básica de la cocina',
      unnamedKitchen: 'Cocina sin nombre',
      contactTitle: 'Contacto',
      addressVisibleLabel: 'Dirección visible al público',
      error: 'Lo sentimos, hubo un error al guardar.',
      addressError: 'La dirección ingresada no se encontró',
      loading: 'Cargando datos...',
    },
    kitchenSettings: {
      nameTitle: 'Elige el nombre para tu cocina',
      nameDescription: 'Este es el nombre que los clientes verán al buscar. Tu número de teléfono solo será visible después de recibir un pedido.',
      locationTitle: 'Ingresa la ubicación de tu cocina',
      locationNote: 'La ubicación debe estar dentro de los condados de Palm Beach, Broward o Miami-Dade',
      labelName: 'Nombre de la cocina',
      labelPhone: 'Teléfono de la cocina',
      labelAddress: 'Dirección',
      labelCity: 'Ciudad',
      labelState: 'Estado',
      labelZip: 'Código postal',
      labelCountry: 'País',
      cancel: 'Cancelar',
      save: 'Guardar cambios',
      validation: {
        required: 'Obligatorio',
        state: 'El estado debe ser {state}',
        zipOnlyNumbers: 'Debe contener solo números',
        zipLength: 'Debe tener exactamente 5 dígitos',
        phoneIncomplete: 'Teléfono incompleto',
        phoneTooLong: 'Teléfono demasiado largo',
      },
    },
    kitchenStatusPanel: {
      title: 'Estado',
      selectFile: 'Por favor selecciona un archivo',
      uploadError: 'Error al cargar el archivo',
      changeProfilePicture: 'Cambiar foto de perfil',
      onlinePrompt: 'Diles a tus clientes que estás listo para recibir pedidos justo ahora.',
      currently: 'Actualmente:',
      isReadyLabel: 'Visibilidad de la cocina:',
      isReady: 'Estoy listo! Quiero que mi cocina sea visible para el público',
      readyVisibilityNote: 'Puedes desmarcar esta opción si necesitas estar fuera de línea (no visible) por un tiempo.',
    },
    kitchenServices: {
      title: 'Servicios',
      delivery: 'Entrega',
      deliveryChargePrompt: 'Selecciona el cargo por entrega por milla',
      noCharge: 'Sin cargo',
      pickup: 'Recogida',
      perMile: '${amount}/milla',
    },
    kitchenPaymentPreferences: {
      title: 'Preferencias de Pago',
      whenToPay: 'Cuándo recibir el pago',
      howToPay: 'Cómo recibir el pago',
      payAtPickup: 'Pagar al recoger',
      upfront: 'Pagar por adelantado',
      cash: 'Efectivo',
      paymentApps: 'Apps de pago (Zelle, Venmo, etc.)',
      other: 'Otro',
    },
    kitchenMenus: {
      title: 'Menús',
      menuItemsLabel: 'Artículos del menú',
      emptyState: 'Aún no hay menús, crea tu primer menú aquí.',
      createPrompt: 'Puedes crear diferentes menús según tus temas y preferencias culinarias.',
      createButton: 'Crear menú nuevo',
      newMenuTitle: 'Nuevo menú',
      inactive: 'Inactivo',
      active: 'Activo',
      cancel: 'Cancelar',
      saveNew: 'Guardar menú nuevo',
      nameLabel: 'Nombre',
      typeLabel: 'Tipo',
      examples: 'p. ej. "Mi menú del almuerzo", "Para compartir", "Delicias de postre"',
      editMenu: 'Editar menú',
      deleteMenu: 'Eliminar menú',
      deleteMenuConfirm: '¿Quieres eliminar este menú junto con todos sus elementos?',
      yes: 'Sí',
      validation: {
        required: 'Obligatorio',
        specialChars: 'No se permiten los caracteres < y >',
        minLength: 'Debe tener al menos 3 caracteres',
        maxLength: 'Debe tener menos de 100 caracteres',
        noNumbers: 'No se permiten números',
        letterRequired: 'Debe contener al menos una letra',
      },
      menuTypes: {
        any: 'Cualquiera',
        seafood: 'Mariscos',
        vegetarian: 'Vegetariano',
        vegan: 'Vegano',
        meat_poultry: 'Carne y aves',
      },
      menuTypeDescriptions: {
        any: 'Menú flexible que puede incluir cualquier mezcla de platillos.',
        seafood: 'Enfocado en platos a base de pescado y mariscos.',
        vegetarian: 'Menú centrado en plantas sin carne ni mariscos.',
        vegan: 'Menú totalmente basado en plantas y sin productos animales.',
        meat_poultry: 'Incluye platos con opciones de carne y aves.',
      },
      removeError: 'Lo sentimos, ocurrió un error al eliminar el menú',
      noMenuItems: 'Aún no se agregaron elementos del menú',
      activeStatus: 'activo',
      inactiveStatus: 'inactivo',
    },
    menuItems: {
      selectFile: 'Por favor selecciona un archivo',
      pictureUploadError: 'La imagen no pudo cargarse',
      uploadError: 'Error al cargar el archivo',
      uploadFailure: 'Lo siento, {message}',
      changePicture: 'Cambiar imagen',
      timeToPrepare: 'Tiempo de preparación',
      minutes: 'minutos',
      ingredients: 'Ingredientes',
      description: 'Descripción',
      editMenuItem: 'Editar elemento del menú',
      addNewItem: 'Agregar nuevo elemento a este menú',
      newItem: 'Nuevo elemento',
      itemName: 'Nombre del elemento',
      timeLabel: 'Tiempo de preparación',
      categoryLabel: 'Categoría',
      priceLabel: 'Precio',
      ingredientsLabel: 'Ingredientes',
      descriptionLabel: 'Descripción',
      itemPlaceholder: 'Lista los ingredientes separados por comas',
      descriptionPlaceholder: 'Describe tu producto aquí',
      min: 'min',
      removeMenuItem: 'Eliminar elemento del menú',
      removeMenuItemConfirm: '¿Quieres eliminar {itemName} de tu menú?',
      deletePrompt: '¿Quieres eliminar este menú junto con todos sus elementos?',
      save: 'Guardar',
      validation: {
        required: 'Obligatorio',
        minLength: 'Debe tener al menos 3 caracteres',
        maxLength: 'Debe tener menos de 100 caracteres',
        ingredientMin: 'Debe tener al menos 3 caracteres',
        ingredientMax: 'Debe tener menos de 500 caracteres',
        descriptionMin: 'Debe tener al menos 10 caracteres',
        descriptionMax: 'Debe tener menos de 500 caracteres',
        priceRequired: 'Obligatorio',
        timeRequired: 'Obligatorio',
        categoryRequired: 'Obligatorio',
      },
    },
  },
};
